export type ColdChainProfileId = 'FROZEN' | 'FRIDGE' | 'COOL' | 'TEMP' | 'OTHER';

export interface ColdChainProfile {
  id: ColdChainProfileId;
  /** °C; `null` = no lower bound */
  min: number | null;
  /** °C; `null` = no upper bound */
  max: number | null;
  labelKey: string;
}

/** Predefined storage ranges of legacy `BeanBase.ColdChainProfile`; `OTHER` takes the bounds the user types. */
export const COLD_CHAIN_PROFILES: readonly ColdChainProfile[] = [
  { id: 'FROZEN', min: null, max: -20, labelKey: 'tracking.servicereq.coldchain.frozen' },
  { id: 'FRIDGE', min: 2, max: 8, labelKey: 'tracking.servicereq.coldchain.fridge' },
  { id: 'COOL', min: 8, max: 15, labelKey: 'tracking.servicereq.coldchain.cool' },
  { id: 'TEMP', min: 15, max: 25, labelKey: 'tracking.servicereq.coldchain.temp' },
  { id: 'OTHER', min: null, max: null, labelKey: 'tracking.servicereq.coldchain.other' }
];

/**
 * Profile of a stored range, as legacy `Journey.getColdChainProfile`: a preset when both bounds
 * match it exactly, `OTHER` when any bound is set, `null` when there are none.
 */
export const matchColdChainProfile = (min?: number | null, max?: number | null): ColdChainProfileId | null => {
  const preset = COLD_CHAIN_PROFILES.find(
    (profile) => profile.id !== 'OTHER' && profile.min === (min ?? null) && profile.max === (max ?? null)
  );
  if (preset) return preset.id;
  return min != null || max != null ? 'OTHER' : null;
};

/** Bounds as legacy `requestLineDesc.xhtml`, a missing one left blank: `2 - 8°C`, `- -20°C`; `null` without bounds. */
export const formatTemperatureBounds = (min?: number | null, max?: number | null): string | null =>
  min == null && max == null ? null : `${min ?? ''} - ${max ?? ''}°C`.trim();
